import * as React from 'react';
import PropTypes from 'prop-types';
import {
  // Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';

import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const accordionStyle = makeStyles((theme) => ({
  accordionSummary: {
    'backgroundColor': 'rgb(235, 235, 235)',
    'borderTopLeftRadius': '4px',
    'borderTopRightRadius': '4px',
    'maxHeight': '40px',
    'minHeight': '40px',
    'marginTop': '8px',
    '&.Mui-expanded': {
      minHeight: '40px',
      maxHeight: '40px',
    },
    'flexDirection': 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
      marginLeft: theme.spacing(1),
    },
  },
}));

export default function CustomAccordion({title, items, defaultExpanded=true}) {
  const classes = accordionStyle();
  const children = items.map((child, index) =>
    <div key={index}>{child}</div>,
  );

  return (
    <Accordion defaultExpanded={defaultExpanded} >
      <AccordionSummary
        expandIcon={<ChevronRightIcon/>}
        aria-controls="panel1-content"
        id="accordion-header"
        className={classes.accordionSummary}
      >
        <Typography variant="subtitle1">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails style={{padding: '15px 16px 15px 25px', overflow: 'hidden'}}>
        {/* <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-end"
          spacing={1}
        > */}
        {children}
        {/* </Grid> */}
      </AccordionDetails>
    </Accordion>
  );
}

CustomAccordion.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  defaultExpanded: PropTypes.bool,
};

